import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit, FaRegClock, FaUser } from 'react-icons/fa';
import {
  MdDateRange,
  MdDelete,
  MdWhatsapp,
  MdLocationOn,
  MdComment,
} from 'react-icons/md';
import { FiTarget } from 'react-icons/fi';
import { BsDownload } from 'react-icons/bs';
import { FiPhoneCall, FiPhoneOff } from 'react-icons/fi';
import { HiDotsVertical } from 'react-icons/hi';
import { FaPhone, FaWpforms } from 'react-icons/fa6';
import { IoSearchOutline } from 'react-icons/io5';
// Custom components
import * as React from 'react';
import { Button, Form } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import axios from 'axios';
import { toast } from 'react-toastify';

import FileUpdate from './FileUpdate';
import DeleteModal from './DeleteModal';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import {
  addBulkData,
  exportAppointmentDetail,
  getPatientExcelData,
  leadGet,
  searchLead,
  updateLead,
  viewLead,
} from '../../../redux/actions/Files.action';
import { allCounselorDetail } from '../../../redux/actions/Files.action';
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import userPhoto from '../../../assets/img/user.png';
import moment from 'moment';
import {
  fetchAllEmailTemplates,
  getMessage,
  getSetting,
} from '../../../redux/actions/Setting.action';
import { callLead } from '../../../redux/actions/IVR.action';
import Modal from 'react-bootstrap/Modal';
// import './styles.css';
import * as XLSX from 'xlsx';
import { FaEye } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { BASEURL } from '../../../baseUrl';
import { getUserData } from '../../../redux/actions/Admin.action';

// Add responsive styles
// const responsiveStyles = `
//   /* Styles for all screen sizes */
//   .mobile-only-button {
//     display: none !important;
//   }

//   @media only screen and (max-width: 768px) {
//     .mobile-only-button {
//       display: inline-flex !important;
//     }
//   }
// `;

const responsiveStyles = `
  .mobile-only-button {
    display: none !important;
  }

  .pagination {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 4px !important;
    padding: 8px 0 !important;
    list-style: none !important;
    margin: 0 auto !important;
  }

  .pagination li a,
  .pagination li span {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 32px !important;
    height: 32px !important;
    padding: 0 6px !important;
    border-radius: 4px !important;
    font-size: 13px !important;
    white-space: nowrap !important;
    cursor: pointer !important;
  }

  @media only screen and (max-width: 768px) {
    .mobile-only-button {
      display: inline-flex !important;
    }

    .pagination {
      gap: 3px !important;
    }

    .pagination li a,
    .pagination li span {
      min-width: 28px !important;
      height: 28px !important;
      font-size: 12px !important;
      padding: 0 5px !important;
    }

    .lead-card {
      padding: 12px !important;
    }

    .lead-card h3 {
      font-size: 1rem !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 8px !important;
    }

    .lead-card h3 span:last-child {
      flex-wrap: wrap !important;
      width: 100% !important;
    }

    .lead-card table td {
      display: block !important;
      width: 100% !important;
      padding: 4px 0 !important;
      border: none !important;
      font-size: 13px !important;
    }

    .lead-card table tr {
      display: block !important;
      margin-bottom: 6px !important;
    }

    .chakra-table__container {
      overflow-x: hidden !important;
    }

    /* --- Mobile responsive fixes for lead card header / action icons --- */
    .lead-card-header {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 10px !important;
      width: 100% !important;
    }

    .lead-card-name {
      width: 100% !important;
    }

    .lead-card-name h3 {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 8px !important;
      width: 100% !important;
    }

    .lead-card-name h3 > span:first-child {
      max-width: 100% !important;
      word-break: break-word !important;
    }

    .lead-card-name h3 > span.flex {
      width: 100% !important;
      flex-wrap: wrap !important;
      justify-content: flex-start !important;
    }

    .lead-card-actions {
      width: 100% !important;
      padding: 0 !important;
      display: block !important;
    }

    .lead-card-actions-inner {
      width: 100% !important;
      justify-content: flex-start !important;
      flex-wrap: wrap !important;
    }

    /* Select All bar */
    .select-all-bar {
      width: 100% !important;
      flex-wrap: wrap !important;
      gap: 8px !important;
    }
  }

  /* --- Fix: on mobile the filter row and search box stack in a column,
     but their inline styles set "flex: 1 1 180px" / "flex: 0 1 320px",
     which is a MAIN-AXIS (height) basis in a column flex container.
     That was forcing huge vertical gaps and squashing the search box
     into a near-square/circle shape. Force them back to a normal
     full-width block below the lg / md breakpoints that switch the
     row to flex-row. --- */
  @media only screen and (max-width: 991.98px) {
    .filter-row {
      flex-wrap: nowrap !important;
      align-items: stretch !important;
    }

    .filter-field {
      flex: 1 1 auto !important;
      min-width: 0 !important;
      width: 100% !important;
    }
  }

  @media only screen and (max-width: 767.98px) {
    .search-box {
      flex: 1 1 auto !important;
      width: 100% !important;
      min-width: 0 !important;
    }
  }
`;
export default function CreateTable() {
  const [updateModal, setUpdateModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateId, setUpdateId] = useState('');
  const [leadId, setLeadId] = useState([]);
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const dispatch = useDispatch();
  const getFile = useSelector((state) => state.files);
  const setting = useSelector((state) => state.setting);
  const adminState = useSelector((state) => state.admin);
  const loggedInUser = adminState?.getUserData?.data?.auth;
  const loggedInUserId = loggedInUser?._id;
  const managers = getFile?.allCounselor?.data?.CounselorsData || [];
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [checked, setChecked] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [selectedMobileNumber, setselectedMobileNumber] = useState();
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
    startDate: '',
    endDate: '',
    status: '',
    managerId: '',
    update_at: '',
  });
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [whatsappInputType, setWhatsappInputType] = useState('');
  const [whatsappDropdownSelection, setWhatsappDropdownSelection] =
    useState('');
  const [whatsAppMessage, setWhatsAppMessage] = useState([]);
  const [otherMessage, setOtherMessage] = useState('');
  const [errors, setErrors] = useState({ dropdown: '', other: '' });
  const [selectedLeadName, setSelectedLeadName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [selectedEmailAddress, setSelectedEmailAddress] = useState('');
  const [emailDropdownSelection, setEmailDropdownSelection] = useState('');
  const [customEmailMessage, setCustomEmailMessage] = useState('');
  const [emailTemplates, setEmailTemplates] = useState([]);

  const [calling, setCalling] = useState(false);
  const [isUpdatingCallStatus, setIsUpdatingCallStatus] = useState(false);
  const openEmailModal = (email, firstName, lastName) => {
    setIsEmailModalOpen(true);
    setSelectedEmailAddress(email);
    setSelectedLeadName(`${firstName} ${lastName}`);
  };

  const [bulkUpdateModal, setBulkUpdateModal] = useState(false);
  const [bulkFollowUpDate, setBulkFollowUpDate] = useState('');
  const [isBulkLoading, setIsBulkLoading] = useState(false);

  const [bulkAssignManagerModal, setBulkAssignManagerModal] = useState(false);
  const [bulkSelectedManagerId, setBulkSelectedManagerId] = useState('');
  const [isBulkManagerLoading, setIsBulkManagerLoading] = useState(false);

  const closeEmailModal = () => {
    setIsEmailModalOpen(false);
    setEmailDropdownSelection('');
    setCustomEmailMessage('');
  };
  useEffect(() => {
    dispatch(fetchAllEmailTemplates()).then((res) => {
      if (res?.status === 200) {
        setEmailTemplates(res?.data?.data || []);
      }
    });
  }, [dispatch]);
  useEffect(() => {
    if (!loggedInUserId) {
      dispatch(getUserData());
    }
  }, [dispatch, loggedInUserId]);

  useEffect(() => {
    if (typeof loggedInUser?.voiceAIDetails?.callStatus === 'boolean') {
      setCalling(loggedInUser.voiceAIDetails.callStatus);
    }
  }, [loggedInUser?.voiceAIDetails?.callStatus]);

  const handleSendEmail = () => {
    let messageToSend = '';
    let subject = '';

    if (emailDropdownSelection === 'custom') {
      subject = 'Custom Message';
      messageToSend = customEmailMessage;
    } else {
      const selectedTemplate = emailTemplates.find(
        (t) => t._id === emailDropdownSelection,
      );
      subject = selectedTemplate?.title || 'No Subject';
      messageToSend = selectedTemplate?.description || '';
    }

    if (!messageToSend) return alert('Message content is empty.');

    // const mailtoLink = `mailto:${selectedEmailAddress}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(messageToSend)}`;
    // window.location.href = mailtoLink;

    // Build Gmail compose URL
    const gmailURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(selectedEmailAddress)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(messageToSend)}`;

    window.open(gmailURL, '_blank');

    closeEmailModal();
  };

  // Whatsapp message handle send function
  const handleSend = () => {
    let hasError = false;
    const newErrors = { dropdown: '', other: '' };

    if (!whatsappDropdownSelection) {
      newErrors.dropdown = 'Please select a message option.';
      hasError = true;
    }

    if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
      newErrors.other = 'Please enter your custom message.';
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    let formattedNumber = selectedMobileNumber;
    // if (!formattedNumber.startsWith('91')) {
    //   formattedNumber = `91${formattedNumber}`;
    // }

    let messageToSend = '';
    if (whatsappDropdownSelection === 'other') {
      messageToSend = otherMessage;
      setOtherMessage('');
    } else {
      const selectedMsgObj = whatsAppMessage.find(
        (msg) => msg._id === whatsappDropdownSelection,
      );
      messageToSend = selectedMsgObj?.description || '';
      setOtherMessage('');
    }

    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappURL = `https://web.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
    closeWhatsappModal();
  };

  const openWhatsappModal = (mobileNumber, firstName, lastName) => {
    setIsWhatsappModalOpen(true);
    setselectedMobileNumber(mobileNumber);
    setSelectedLeadName(`${firstName} ${lastName}`);
  };

  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
    setWhatsappDropdownSelection('');
    setOtherMessage('');
    setErrors({ dropdown: '', other: '' });
  };

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  const limits = {
    page: mainPage,
    limit: rowsPerPage,
    managerId: searchDefault.managerId || '',
    search: searchDefault.search || '',
    startDate: searchDefault.startDate || '',
    endDate: searchDefault.endDate || '',
    status: searchDefault.status || '',
    update_at: searchDefault.update_at || '',
  };

  useEffect(() => {
    dispatch(getSetting());
    dispatch(getMessage())
      .then((res) => {
        if (res?.status == 200) {
          setWhatsAppMessage(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  useEffect(() => {
    if (
      Array.isArray(setting?.getSetting?.leadStatuses?.leadStatuses) &&
      setting?.getSetting?.leadStatuses?.leadStatuses.length > 0
    ) {
      setLeadStatuses(setting.getSetting.leadStatuses?.leadStatuses || []);
    }
  }, [setting]);

  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(
      (status) => status.title.toLowerCase() === leadStatusName.toLowerCase(),
    );

    return status ? status.backgroundColor : 'transparent';
  };

  const navigate = useNavigate();

  const handleDropdownToggle = (isOpen, id) => {
    if (isOpen) {
      setActiveDropdownId(id);
    }
  };

  const handleNavigate = (res) => {
    navigate('/master/addAppointment', {
      state: { showModal: true, userData: res },
    });
  };

  // const handleCheckboxChange = (e, id) => {
  //   if (e.target.checked) {
  //     setChecked(true);
  //     setLeadId((prev) => {
  //       if (!prev.includes(id)) {
  //         return [...prev, id];
  //       }
  //       return prev;
  //     });
  //   } else {
  //     setChecked(false);
  //     setLeadId((prev) => prev.filter((lead) => lead !== id));
  //   }
  // };

  const handleCheckboxChange = (e, id) => {
    setLeadId((prev) => {
      const updated = e.target.checked
        ? [...prev, id]
        : prev.filter((lead) => lead !== id);
      setChecked(updated.length > 0);
      return updated;
    });
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    setSearchDefault((prev) => {
      const updatedSearchDefault = {
        ...prev,
        [name]: value,
        page: mainPage,
        limit: rowsPerPage,
      };
      const queryParams = new URLSearchParams(updatedSearchDefault).toString();
      dispatch(searchLead(queryParams));
      return updatedSearchDefault;
    });
  };

  const handleStatusChange = (e) => {
    const { value } = e.target;

    setSearchDefault((prev) => {
      const updatedSearchDefault = {
        ...prev,
        status: value,
        page: mainPage,
        limit: rowsPerPage,
      };
      const queryParams = new URLSearchParams(updatedSearchDefault).toString();
      dispatch(searchLead(queryParams));
      return updatedSearchDefault;
    });
  };

  const handleManagerChange = (e) => {
    const managerId = e.target.value;
    setSearchDefault((prev) => ({
      ...prev,
      managerId: managerId,
    }));
    setMainPage(1);
  };

  const handleAddLead = () => {
    navigate('/master/addLead');
  };

  const updateToggle = (id) => {
    setUpdateModal(!updateModal);
    // dispatch(viewLead(id?._id))
    if (!updateModal) {
      setUpdateId(id);
    } else {
      setUpdateId('');
      const updatedSearchParams = {
        ...searchDefault,
        page: mainPage,
        limit: rowsPerPage,
        search: searchQuery,
        startDate: searchDefault.startDate,
        endDate: searchDefault.endDate,
        status: searchDefault.status,
        // counselorAssignName: formValues.type || ''
      };

      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchLead(queryParams));
    }
  };

  const viewToggle = () => {
    setViewModal(!viewModal);
  };

  const handleView = (id) => {
    dispatch(viewLead(id));
    navigate(`/master/viewLead/${id}`);
  };

  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const deleteData = (id) => {
    setDeleteModal(!deleteModal);
    setLeadId([id]);
  };

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: 1,
      limit: rowsPerPage,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
    };
    setSearchDefault(newSearchParams);
    setIsLoading(true);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchLead(queryParams)).finally(() => setIsLoading(false));
  };

  const ChangeMainPage = (selected) => {
    const newPage = parseInt(selected.selected) + 1;
    setMainPage(newPage);

    const updatedSearchParams = {
      ...searchDefault,
      page: newPage,
      search: searchQuery,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
    };

    setSearchDefault(updatedSearchParams);

    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);

    const updatedSearchParams = {
      ...searchDefault,
      page: 1,
      limit: newRowsPerPage,
    };

    setSearchDefault(updatedSearchParams);

    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchLead(queryParams));
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getFile?.getAllLead?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    const { search, startDate, endDate, status, managerId, update_at } =
      searchDefault;
    const isFilterApplied =
      search || startDate || endDate || status || managerId || update_at;

    const updatedSearchParams = {
      ...searchDefault,
      page: mainPage,
      limit: rowsPerPage,
    };

    const queryParams = new URLSearchParams(updatedSearchParams).toString();

    if (isFilterApplied) {
      dispatch(searchLead(queryParams));
    } else {
      dispatch(leadGet(limits));
    }
  }, [mainPage, rowsPerPage, searchDefault]);

  // const handleExport = () => {
  //   setIsLoading(true);
  //   const data = {
  //     search: searchDefault.search,
  //     startDate: searchDefault.startDate,
  //     endDate: searchDefault.endDate,
  //     status: searchDefault.status,
  //     managerId: searchDefault.managerId,
  //   };
  //   dispatch(getPatientExcelData(data)).finally(() => setIsLoading(false));
  //   setIsExporting(true);
  // };

  // useEffect(() => {
  //   if (isExporting && getFile?.getPatientExcel?.data?.PatientData?.length) {
  //     const exportData = getFile.getPatientExcel.data.PatientData.map((res) => ({
  //       firstName: res?.firstName || "",
  //       lastName: res?.lastName || "",
  //       phoneNumber: res?.phoneNumber || "",
  //       email: res?.email || "",
  //       city: res?.city || "",
  //       leadFrom: res?.leadFrom || "",
  //       counselorAssign: res?.counselorAssign?.name || "",
  //       leadStatus: res?.leadStatus || "",
  //       date: moment(res?.createdAt).format("DD/MM/YYYY") || "",
  //       time: res?.createdAt ? formatTime(res?.createdAt) : "",
  //       remark: res?.remark || "",
  //     }));

  //     // Generate HTML table with CSS
  //     const htmlContent = `
  //       <html>
  //         <head>
  //           <style>
  //             table {
  //               border-collapse: collapse;
  //               width: 100%;
  //               font-family: Arial, sans-serif;
  //             }
  //             th, td {
  //               border: 1px solid #ddd;
  //               padding: 8px;
  //               text-align: left;
  //             }
  //             th {
  //               background-color: #03367f;
  //               color: #ffffff;
  //               font-weight: bold;
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           <table>
  //             <thead>
  //               <tr>
  //                 <th>First Name</th>
  //                 <th>Last Name</th>
  //                 <th>Phone Number</th>
  //                 <th>Email</th>
  //                 <th>Location</th>
  //                 <th>Lead From</th>
  //                 <th>Lead Assign</th>
  //                 <th>Lead Status</th>
  //                 <th>Date</th>
  //                 <th>Time</th>
  //                 <th>Remarks</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               ${exportData
  //                 .map(
  //                   (row) => `
  //                     <tr>
  //                       <td>${row.firstName}</td>
  //                       <td>${row.lastName}</td>
  //                       <td>${row.phoneNumber}</td>
  //                       <td>${row.email}</td>
  //                       <td>${row.city}</td>
  //                       <td>${row.leadFrom}</td>
  //                       <td>${row.counselorAssign}</td>
  //                       <td>${row.leadStatus}</td>
  //                       <td>${row.date}</td>
  //                       <td>${row.time}</td>
  //                       <td>${row.remark}</td>
  //                     </tr>
  //                   `
  //                 )
  //                 .join('')}
  //             </tbody>
  //           </table>
  //         </body>
  //       </html>
  //     `;

  //     // Create Blob and download
  //     const blob = new Blob([htmlContent], { type: 'application/vnd.ms-excel' });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = 'Patient_Data.xlsx'; // Note: .xls extension
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     window.URL.revokeObjectURL(url);

  //     // Reset exporting flag
  //     setIsExporting(false);
  //   }
  // }, [getFile?.getPatientExcel?.data?.PatientData, isExporting]);
  const handleExport = () => {
    setIsLoading(true);
    const data = {
      search: searchDefault.search,
      startDate: searchDefault.startDate,
      endDate: searchDefault.endDate,
      status: searchDefault.status,
      managerId: searchDefault.managerId,
    };
    dispatch(getPatientExcelData(data)).finally(() => setIsLoading(false));
    setIsExporting(true);
  };

  useEffect(() => {
    if (isExporting && getFile?.getPatientExcel?.data?.PatientData?.length) {
      const exportData = getFile.getPatientExcel.data.PatientData.map(
        (res) => ({
          'First Name': res.firstName || '',
          'Last Name': res.lastName || '',
          'Phone Number': res.phoneNumber || '',
          Email: res.email || '',
          city: res?.city || '',
          leadFrom: res?.leadFrom || '',
          counselorAssign: res?.counselorAssign?.name || '',
          leadStatus: res?.leadStatus || '',
          date: moment(res?.createdAt).format('DD/MM/YYYY') || '',
          time: res?.createdAt ? formatTime(res?.createdAt) : '',
          remark: res?.remark || '',
        }),
      );

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Leads');

      XLSX.writeFile(wb, 'Leads.xls');
      setIsExporting(false); // reset flag
    }
  }, [getFile?.getPatientExcel?.data?.PatientData]);
  // const formatTime = (dateString) => {
  //   const date = new Date(dateString);
  //   let hours = date.getUTCHours();
  //   const minutes = date.getUTCMinutes();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';

  //   hours = hours % 12;
  //   hours = hours || 12;
  //   const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

  //   return `${hours}:${minutesFormatted} ${ampm}`;
  // };
  const formatTime = (dateString) => {
    const date = new Date(dateString);

    // Add 5 hours and 30 minutes
    date.setUTCHours(date.getUTCHours() + 5);
    date.setUTCMinutes(date.getUTCMinutes() + 30);

    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12;
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesFormatted} ${ampm}`;
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('bulkUploadFile', file);
      dispatch(addBulkData(formData, limits, searchDefault.status)).finally(
        () => setIsLoading(false),
      );
    }
  };

  const handleCallingToggle = async () => {
    if (!loggedInUserId) {
      toast.error('Unable to update call status. Please try again.');
      return;
    }
    const newStatus = !calling;
    try {
      setIsUpdatingCallStatus(true);
      const formData = new FormData();
      const currentVoice = loggedInUser?.voiceAIDetails || {};

      formData.append(
        'voiceAIDetails',
        JSON.stringify({
          OMNIDIM_API_KEY: currentVoice.OMNIDIM_API_KEY,
          OMNIDIM_DEFAULT_PHONE_NUMBER_ID:
            currentVoice.OMNIDIM_DEFAULT_PHONE_NUMBER_ID,
          OMNIDIM_BASE_URL: currentVoice.OMNIDIM_BASE_URL,
          callStatus: newStatus,
        }),
      );

      const token = localStorage.getItem('token');
      await axios.put(
        `${BASEURL}/subAdmin/updateSubAdmin/${loggedInUserId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setCalling(newStatus);
      toast.success(
        `Calling ${newStatus ? 'started' : 'stopped'} successfully.`,
      );
      dispatch(getUserData());
    } catch (error) {
      console.error('Failed to update call status', error);
      toast.error(
        error?.response?.data?.message || 'Failed to update call status.',
      );
    } finally {
      setIsUpdatingCallStatus(false);
    }
  };
  const handleVoiceDownload = (url, fileName) => {
    if (!url) {
      return toast.error('File not available');
    }

    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(() => toast.error('Failed to download'));
  };

  return (
    <>
      {isLoading && (
        <div className="loaderAdd">
          <div className="loader_line">
            <img src={localStorage.getItem('logo')} className="w-[200px]" />
          </div>
        </div>
      )}
      <style>{responsiveStyles}</style>
      {/* <div className="mt-[120px] d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-end mb-5 gap-3 flex-wrap"> */}
      <div
        className="mt-[80px] d-flex flex-column gap-3 mb-5"
        style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        }}
      >
        {/* Left Filters */}
        <div
          className="d-flex flex-column flex-lg-row gap-4 w-100 mb-3 mb-lg-0 filter-row"
          style={{ flexWrap: 'wrap', alignItems: 'flex-end' }}
        >
          {/* Start Date */}
          <div
            className="filter-field"
            style={{ minWidth: '180px', flex: '1 1 180px' }}
          >
            <label className="text-sm">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={searchDefault.startDate}
              onChange={handleDateChange}
              className="w-100 outline-none"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '8px 12px',
                background: '#fff',
              }}
            />
          </div>
          {/* End Date */}
          <div
            className="filter-field"
            style={{ minWidth: '180px', flex: '1 1 180px' }}
          >
            <label className="text-sm">End Date</label>
            <input
              type="date"
              name="endDate"
              value={searchDefault.endDate}
              onChange={handleDateChange}
              className="w-100 outline-none"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '8px 12px',
                background: '#fff',
              }}
            />
          </div>
          {/* Status */}
          <div
            className="filter-field"
            style={{ minWidth: '180px', flex: '1 1 180px' }}
          >
            <label className="text-sm block mb-1">Status</label>
            <select
              onChange={handleStatusChange}
              value={searchDefault.status}
              className="w-100 outline-none"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '8px 12px',
                background: '#fff',
              }}
            >
              <option value="" disabled>
                Select Lead Status
              </option>
              {setting?.getSetting?.leadStatuses?.leadStatuses?.map(
                (status) => (
                  <option key={status._id} value={status.title}>
                    {status.title}
                  </option>
                ),
              )}
            </select>
          </div>
          {/* Manager Filter */}
          {localStorage.getItem('type') !== 'Manager' && (
            <div
              className="filter-field"
              style={{ minWidth: '180px', flex: '1 1 180px' }}
            >
              <label className="text-sm block mb-1">Manager</label>
              <select
                onChange={(e) => handleManagerChange(e)}
                value={searchDefault.managerId || ''}
                className="w-100 outline-none"
                style={{
                  border: '1px solid #dee2e6',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  background: '#fff',
                }}
              >
                <option value="">Select Manager</option>
                <option value="no_assign">No Assign</option>
                {managers.map((manager) => (
                  <option key={manager._id} value={manager._id}>
                    {manager.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* Right Actions: single line on large screen */}
        {/* <div className="d-flex flex-column flex-lg-row align-items-stretch justify-between align-items-lg-center gap-2 w-100 w-lg-auto"> */}
        <div
          className="d-flex flex-column flex-md-row gap-2 w-100 align-items-md-center justify-content-between"
          style={{ marginTop: '8px' }}
        >
          {/* Updated On */}
          <div style={{ minWidth: '180px' }}>
            <label className="text-sm">Updated On</label>
            <input
              type="date"
              name="update_at"
              value={searchDefault.update_at}
              onChange={handleDateChange}
              className="w-100 outline-none"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                padding: '8px 12px',
                background: '#fff',
              }}
            />
          </div>
          {/* Search */}
          <div
            className="bg-white flex items-center gap-2 search-box"
            style={{
              border: '1px solid #dee2e6',
              borderRadius: '999px',
              padding: '10px 20px',
              flex: '0 1 320px',
            }}
          >
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={handleSearch}
              className="w-100 outline-none"
              placeholder="Search..."
            />
          </div>

          {/* <div className="d-flex flex-wrap gap-2"> */}
          <div
            className="d-flex flex-wrap gap-2 align-items-center"
            style={{ marginTop: 0, flexShrink: 0 }}
          >
            {/* Download */}
            {/* {loggedInUser?.voiceAIPermission && (
              <Button
                className={`fw-bold d-flex align-items-center border-0 justify-content-center 
                        ${calling ? 'bg-danger' : '!bg-theme-dark'}`}
                onClick={handleCallingToggle}
                disabled={isUpdatingCallStatus || !loggedInUserId}
              >
                {isUpdatingCallStatus ? (
                  <>
                    <FaRegClock className="me-2" />
                    Updating...
                  </>
                ) : calling ? (
                  <>
                    <FiPhoneOff className="me-2" />
                    Calling Stop
                  </>
                ) : (
                  <>
                    <FiPhoneCall className="me-2" />
                    Calling Start
                  </>
                )}
              </Button>
            )} */}

            <Button
              className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
              onClick={handleExport}
              // style={{ width: '100%' }}
            >
              <BsDownload className="me-2" />
              Download
            </Button>

            {/* Add & Upload */}
            {localStorage.getItem('type') !== 'Lead' && (
              <>
                <Button
                  onClick={handleAddLead}
                  className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <IoMdAdd className="me-2" />
                  Add Lead
                </Button>
                <label>
                  <input
                    type="file"
                    className="d-none"
                    accept=".xlsx"
                    onChange={handleFileUpload}
                  />
                  <div className="!bg-theme-dark text-white py-[6px] px-[12px] rounded cursor-pointer fw-bold d-flex align-items-center justify-content-center">
                    <IoMdAdd className="me-2" />
                    Upload
                  </div>
                </label>
              </>
            )}

            {/* Delete All (if checked) */}
            {/* {checked && (
              <Button
                onClick={() => deleteToggle(leadId)}
                className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
              >
                Delete All
              </Button>
            )} */}
            {/* {checked && (
              <>
                <Button
                  onClick={() => setBulkUpdateModal(true)}
                  className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <FaRegClock className="me-2" />
                  Set Follow-Up ({leadId.length})
                </Button>
                <Button
                  onClick={() => setBulkAssignManagerModal(true)}
                  className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <FaUser className="me-2" />
                  Assign Manager ({leadId.length})
                </Button>
                <Button
                  onClick={() => deleteToggle(leadId)}
                  className="bg-danger fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <MdDelete className="me-2" />
                  Delete All ({leadId.length})
                </Button>
              </>
            )} */}
          </div>
        </div>
      </div>

      <div className="mt-[50px] mb-4">
        {/* <div className="d-flex flex-column flex-lg-row mb-4 gap-2 gap-lg-0 align-items-stretch align-items-lg-center"> */}
        <div className="d-flex flex-column mb-4 gap-2">
          <h2 className="mb-0 fw-bold">Lead List</h2>
          <div className="ms-lg-auto border-r pe-3 me-3">
            Total Records:{' '}
            <span className="text-success border-b border-success">
              {getFile?.getAllLead?.data?.totalCount || 0}
            </span>
          </div>
          <div className="d-flex align-items-center gap-2">
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>

        {getFile?.getAllLead?.data?.PatientData?.length > 0 && (
          <div className="d-flex flex-wrap w-100 select-all-bar align-items-center justify-content-between bg-light rounded px-3 py-2 mb-3 border gap-2">
            <div className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                className="accent-theme-dark w-[16px] h-[16px] cursor-pointer"
                checked={
                  getFile.getAllLead.data.PatientData.length > 0 &&
                  getFile.getAllLead.data.PatientData.every((r) =>
                    leadId.includes(r._id),
                  )
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    const allIds = getFile.getAllLead.data.PatientData.map(
                      (r) => r._id,
                    );
                    setLeadId(allIds);
                    setChecked(true);
                  } else {
                    setLeadId([]);
                    setChecked(false);
                  }
                }}
              />
              <span className="text-sm fw-medium">
                {leadId.length > 0
                  ? `${leadId.length} lead(s) selected`
                  : 'Select All'}
              </span>
              {leadId.length > 0 && (
                <button
                  className="text-sm text-blue-600 underline cursor-pointer bg-transparent border-0"
                  onClick={() => {
                    setLeadId([]);
                    setChecked(false);
                  }}
                >
                  Clear Selection
                </button>
              )}
            </div>

            {checked && (
              <div className="d-flex flex-wrap gap-2">
                <Button
                  onClick={() => setBulkUpdateModal(true)}
                  className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <FaRegClock className="me-2" />
                  Set Follow-Up ({leadId.length})
                </Button>
                <Button
                  onClick={() => setBulkAssignManagerModal(true)}
                  className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <FaUser className="me-2" />
                  Assign Manager ({leadId.length})
                </Button>
                <Button
                  onClick={() => deleteToggle(leadId)}
                  className="bg-danger fw-bold d-flex align-items-center border-0 justify-content-center"
                >
                  <MdDelete className="me-2" />
                  Delete All ({leadId.length})
                </Button>
              </div>
            )}
          </div>
        )}

        <TableContainer
          responsive="lg"
          className="table-container overflow-y-auto"
        >
          <Table variant="striped" colorScheme="blackAlpha">
            {/* <Thead>
              <Tr>
                <Th></Th>
                <Th>Date</Th>
                <Th>Branch</Th>
                <Th>First Name</Th> */}
            {/* <Th>Middle Name</Th> */}
            {/* <Th>Last Name</Th>
                <Th>Phone No.</Th>
                <Th>Lead Status</Th>
                <Th>Lead From</Th>
                <Th>Gender</Th>
                <Th>Date Of Birth</Th>
                <Th>Country</Th>
                <Th>State</Th>
                <Th>City</Th>
                <Th>Area</Th>
                <Th>Lead Received On</Th>
                <Th>Campaign</Th>
                <Th>Campaign Detail</Th>
                <Th>Remark</Th>
                <Th>Next Followup Date</Th>
                <Th>From</Th>
                <Th>To</Th>
                <Th>Nationality</Th>
                <Th>Lead assign</Th>
                <Th>Occupation</Th>
                <Th>Email</Th>
                <Th>Address</Th>
                <Th>Pincode</Th>
                <Th>Photo</Th>
                <Th>Lead FollowUp Remark</Th>
                <Th>User</Th>
                <Th style={{ position: 'sticky', right: 80, background: '#fff', zIndex: 2, minWidth: '50px' }}>WhatsApp</Th> */}
            {/* <Th
                  style={{
                    position: 'sticky',
                    right: 80,
                    background: '#fff',
                    zIndex: 2,
                    minWidth: '50px',
                    display: 'table-cell',
                    '@media screen and (min-width: 768px)': {
                      display: 'table-cell',
                      position: 'sticky',
                      right: '80px'
                    }
                  }}
                >
                  Phone
                </Th>   */}
            {/* <Th className="phone-column">Phone</Th> */}
            {/* <Th className="phone-column" style={{ position: 'sticky', right: 42, background: '#fff', zIndex: 2, minWidth: '50px' }}>Phone</Th>

                {
                  localStorage.getItem('type') !== 'Lead' && (
                    <>
                      <Th style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 2, minWidth: '50px' }}>Action</Th>

                    </>
                  )
                }
              </Tr>
            </Thead> */}
            {/* <Tbody>

              {
                getFile?.getAllLead?.data?.PatientData?.length > 0 ? (
                  getFile?.getAllLead?.data?.PatientData?.map((res) => {
                    return (
                      <Tr>

                        <Td>
                          <input type="checkBox" className='accent-theme-dark' checked={leadId.includes(res._id)} onChange={(e) => handleCheckboxChange(e, res._id)} />
                        </Td>
                        <Td>{res.createdAt ? moment(res.createdAt).format('DD/MM/YYYY') : ''}</Td>
                        <Td>{res.branch}</Td>
                        <Td className='capitalize'>{res.firstName}</Td> */}
            {/* <Td>{res.middleName ? `${res.middleName.charAt(0).toUpperCase()}.` : ''}</Td> */}
            {/* <Td className='capitalize'>{res.lastName}</Td>
                        <Td>{res.phoneNumber}</Td>
                        <Td className="capitalize"> */}
            {/* <button
                            disabled={localStorage.getItem('type')?.toLowerCase().trim() === 'lead'}
                            onClick={() => updateToggle(res)}
                            style={{
                              background: res.leadStatus ? getBackgroundColor(res.leadStatus.trim().toLowerCase()) : "transparent",
                              color: res.leadStatus ? "white" : "black"
                            }}
                            className="cursor-pointer px-3 py-1 rounded inline-block text-sm"
                          >
                            {res.leadStatus}
                          </button> */}
            {/* <button
                            disabled={localStorage.getItem('type') === 'Lead'}
                            onClick={() => updateToggle(res)}
                            style={{ background: `${res.leadStatus ? `${getBackgroundColor(res.leadStatus)}` : "transparent"}`, color: `${res.leadStatus ? `white` : "black"}` }}
                            className={`cursor-pointer  px-3 py-1 rounded inline-block text-sm`}
                          >
                            {res.leadStatus}
                          </button>
                        </Td> 

                        <Td>{res.leadFrom}</Td>
                        <Td>{res.gender}</Td>
                        <Td>{res.dateOfBirth ? moment(res.dateOfBirth).format('DD/MM/YYYY') : ''}</Td>
                        <Td>{res.country}</Td>
                        <Td>{res.state}</Td>
                        <Td>{res.city}</Td>
                        <Td>{res.area}</Td>
                        <Td>{res.leadReceived}</Td>
                        <Td>{res.campaign[0]?.cname}</Td>
                        <Td>{res.campaign[0]?.description}</Td>
                        <Td>{res.remark}</Td>
                        <Td>{res.nextFollowUpDate ? moment(res.nextFollowUpDate).format('DD/MM/YYYY') : ''}</Td>
                        <Td>{res.from ? formatTime(res.from) : ''}</Td>
                        <Td>{res.to ? formatTime(res.to) : ''}</Td>
                        <Td>{res.nationality}</Td>
                        <Td>{res.counselorAssignName}</Td>
                        <Td>{res.occupation}</Td>
                        <Td>{res.email}</Td>
                        <Td>{res.address}</Td>
                        <Td>{res.pincode}</Td>*/}
            {/* <Td><img src={res.photo} alt='user photo' /></Td> */}
            {/* <Td><img src={res.photo || userPhoto} alt='user photo' width='60px' /></Td>
                        <Td>{res.leadFollowUpRemark}</Td>
                        <Td>{res.leadGeneratedByName}</Td>
                        <Td style={{
                          position: 'sticky',
                          // right: 60,
                          right: 80,
                          background: '#fff',
                          zIndex: activeDropdownId === res._id ? 9 : 'auto',
                          textAlign: 'center',
                        }}>
                          <div className="d-flex gap-2 fs-6 fw-bold" onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)}>
                            <MdWhatsapp className="text-success" size={30} />
                          </div>
                        </Td> */}
            {/* <Td
                      style={{
                        position: 'sticky',
                        right: 80,
                        background: '#fff',
                        zIndex: activeDropdownId === res._id ? 9 : 'auto',
                        textAlign: 'center',
                      }}
                      > 
                         <Td className="phone-cell">
                        <button
                          className="text-success"
                          onClick={() => handlePhoneClick(res.phoneNumber)}
                        >
                          <FaPhone size={25} />
                        </button>
                      </Td>  */}
            {/* <Td className="phone-column" style={{ position: 'sticky', right: 42, background: 'inherit', zIndex: 2 }}>
                          <button
                            onClick={() => handlePhoneClick(res.phoneNumber)}
                            className="btn btn-link p-0 text-primary"
                          >
                            <FaPhone size={25} />
                          </button>
                        </Td>
                        {
                          localStorage.getItem('type') !== 'Lead' && (
                            <Td style={{
                              position: 'sticky',
                              right: 0,
                              background: '#fff',
                              zIndex: activeDropdownId === res._id ? 9 : 'auto',
                            }}>
                              <>
                                <Dropdown className='action_menu' align={'start'} style={{ zIndex: 999 }} onToggle={(isOpen) => handleDropdownToggle(isOpen, res._id)} >
                                  <Dropdown.Toggle className='bg-transparent !border-none'>
                                    <HiDotsVertical className='text-dark fw-bold fs-4' />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className='!z-[99999]'>
                                    <Dropdown.Item onClick={() => { viewToggle(); handleView(res?._id) }} className='d-flex gap-2 fs-6 fw-bold'>
                                      < FiTarget className='text-primary' />View
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => { updateToggle(res) }} className='d-flex gap-2 fs-6 fw-bold'>
                                      <FaEdit className='text-success' />Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => deleteData(res?._id)} className='d-flex gap-2 fs-6 fw-bold'>
                                      <MdDelete className='text-danger' />Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </>

                            </Td>
                          )}
                      </Tr>
                    );
                  })
                ) : (
                  <Tr>
                    <Td colSpan="35" className="text-center">No data available</Td>
                  </Tr>
                )
              }
            </Tbody> */}

            {getFile?.getAllLead?.data?.PatientData?.length > 0 ? (
              getFile?.getAllLead?.data?.PatientData?.map((res) => (
                // <div
                //   key={res._id}
                //   className="lead-card mb-4 bg-white rounded-lg shadow p-4"
                // >
                <div
                  key={res._id}
                  className={`lead-card mb-4 bg-white rounded-lg shadow p-4 transition-all ${
                    leadId.includes(res._id)
                      ? 'border-2 border-blue-500'
                      : 'border border-transparent'
                  }`}
                >
                  {/* Checkbox row */}
                  <div className="d-flex lead-card-header">
                    <div className="sec-div lead-card-name">
                      <div className="flex items-center gap-2 mb-2">
                        <input
                          type="checkbox"
                          className="accent-theme-dark w-[16px] h-[16px] cursor-pointer"
                          checked={leadId.includes(res._id)}
                          onChange={(e) => handleCheckboxChange(e, res._id)}
                        />
                        <span className="text-xs text-gray-400">
                          Select for bulk update
                        </span>
                      </div>
                      <h3 className="text-xl font-medium mb-3 text-blue-900 flex items-center justify-between">
                        <span
                          className="cursor-pointer hover:underline"
                          onClick={() => updateToggle(res)}
                        >
                          <FaUser
                            className="inline-block mr-2 text-blue-900"
                            size="18px"
                          />
                          {res.firstName} {res.lastName}
                        </span>

                        {/* RIGHT SIDE DOWNLOAD BUTTONS */}
                        <span className="flex gap-3">
                          {/* Call Recording Button */}
                          {res?.voiceAIRecording !== '' && (
                            <Button
                              className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center text-white px-3 py-2 rounded cursor-pointer"
                              onClick={() =>
                                window.open(res?.voiceAIRecording, '_blank')
                              }
                            >
                              <BsDownload className="me-2" />
                              Call Recording
                            </Button>
                          )}

                          {/* VoiceAI PDF Button */}
                          {res?.voiceAIPdf !== '' && (
                            <Button
                              className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center text-white px-3 py-2 rounded cursor-pointer"
                              onClick={async () => {
                                try {
                                  const fileUrl = res.voiceAIPdf.startsWith(
                                    'http',
                                  )
                                    ? res.voiceAIPdf
                                    : `${BASEURL}${res.voiceAIPdf}`;

                                  const response = await fetch(fileUrl, {
                                    mode: 'cors',
                                  });
                                  const blob = await response.blob();
                                  const url = window.URL.createObjectURL(blob);
                                  const a = document.createElement('a');
                                  a.href = url;
                                  a.download = `VoiceAI-${res?._id || 'File'}.pdf`;
                                  document.body.appendChild(a);
                                  a.click();
                                  a.remove();
                                  window.URL.revokeObjectURL(url);
                                } catch (error) {
                                  console.error('Download failed:', error);
                                  alert(
                                    'Unable to download the file. Please try again.',
                                  );
                                }
                              }}
                            >
                              <BsDownload className="me-2" />
                              Voice AI PDF
                            </Button>
                          )}
                        </span>
                      </h3>
                    </div>

                    <Td
                      py="1"
                      colSpan={3}
                      style={{ width: '100%' }}
                      className="lead-card-actions"
                    >
                      <div
                        className="d-flex lead-card-actions-inner"
                        style={{ width: '100%', justifyContent: 'flex-end' }}
                      >
                        <Dropdown
                          align="end"
                          onToggle={(isOpen) =>
                            handleDropdownToggle(isOpen, res._id)
                          }
                        >
                          <Dropdown.Toggle
                            className="bg-transparent !border-none"
                            style={{
                              width: 42,
                              height: 42,
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <HiDotsVertical
                              className="text-dark fw-bold"
                              style={{ fontSize: '24px' }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="!z-[9999]">
                            <Dropdown.Item
                              onClick={() => updateToggle(res)}
                              className="d-flex gap-2 fs-6 fw-bold"
                            >
                              <FaEdit className="text-success" /> Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => deleteData(res._id)}
                              className="d-flex gap-2 fs-6 fw-bold text-danger"
                            >
                              <MdDelete className="text-danger" /> Delete
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleView(res._id)}
                              className="d-flex gap-2 fs-6 fw-bold"
                            >
                              <FaEye className="text-info" /> View
                            </Dropdown.Item>
                            {localStorage.getItem('isIvr') === 'true' && (
                              <Dropdown.Item
                                onClick={() =>
                                  dispatch(callLead(res._id, 'lead'))
                                }
                                className="d-flex gap-2 fs-6 fw-bold"
                              >
                                <FaPhone className="text-primary" /> Call
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item
                              onClick={() =>
                                openWhatsappModal(
                                  res.phoneNumber,
                                  res.firstName,
                                  res.lastName,
                                )
                              }
                              className="d-flex gap-2 fs-6 fw-bold"
                            >
                              <MdWhatsapp className="text-success" /> Send
                              Message
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() =>
                                openEmailModal(
                                  res.email,
                                  res.firstName,
                                  res.lastName,
                                )
                              }
                              className="d-flex gap-2 fs-6 fw-bold"
                            >
                              <MdEmail className="text-primary" /> Send Email
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Td>
                  </div>

                  <TableContainer>
                    <Table variant="simple">
                      <Tbody>
                        <Tr>
                          <Td fontWeight="bold" py="1" lineHeight="short">
                            <FaWpforms className="inline-block mr-2 text-blue-500" />
                            Lead Status:&nbsp;&nbsp;
                            <button
                              disabled={
                                localStorage
                                  .getItem('type')
                                  ?.toLowerCase()
                                  .trim() === 'lead'
                              }
                              onClick={() => updateToggle(res)}
                              style={{
                                background: res.leadStatus
                                  ? getBackgroundColor(
                                      res.leadStatus.trim().toLowerCase(),
                                    )
                                  : 'transparent',
                                color: res.leadStatus ? 'white' : 'black',
                              }}
                              className="cursor-pointer px-2 py-0.5 rounded"
                            >
                              {res.leadStatus}
                            </button>
                          </Td>
                          <Td fontWeight="bold" py="1" lineHeight="short">
                            <MdDateRange className="inline-block  mr-2  text-green-500" />
                            Date:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.createdAt
                                ? moment(res.createdAt).format('DD/MM/YYYY')
                                : ''}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1" lineHeight="short">
                            <FaRegClock className="inline-block  mr-2  text-orange-500" />
                            Time:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.createdAt ? formatTime(res.createdAt) : ''}
                            </span>
                          </Td>
                          {/* <Td w="50px" py="1">
                            <div className="d-flex gap-2"> */}
                          {/* <Td py="1" colSpan={3}>
                            <div className="d-flex flex-wrap gap-2">
                              <button
                                  className="text-primary"
                                  onClick={() => handlePhoneClick(res.phoneNumber)}
                                  title="Call"
                                >
                                  <FaPhone size={18} />
                                </button>
                              <button
                                className="text-blue-500 hover:text-blue-700"
                                onClick={() =>
                                  openEmailModal(
                                    res.email,
                                    res.firstName,
                                    res.lastName,
                                  )
                                }
                                title="Send Email"
                                style={{ marginLeft: 10 }}
                              >
                                <MdEmail size={28} />
                              </button>

                              <button
                                className="text-green-500 hover:text-green-700"
                                onClick={() =>
                                  openWhatsappModal(
                                    res.phoneNumber,
                                    res.firstName,
                                    res.lastName,
                                  )
                                }
                                title="WhatsApp"
                              >
                                <MdWhatsapp size={28} />
                              </button>
                              <button
                                className="text-blue-500"
                                onClick={() => handleView(res._id)}
                                title="View"
                              >
                                <FaEye size={28} />
                              </button>
                              <button
                                className="text-success"
                                onClick={() => updateToggle(res)}
                                title="Edit"
                              >
                                <FaEdit size={28} />
                              </button>
                              <button
                                className="text-red-500"
                                onClick={() => deleteData(res._id)}
                                title="Delete"
                              >
                                <MdDelete size={28} />
                              </button>
                            </div>
                          </Td> */}

                          {/* <Td py="1" colSpan={3}>
                            <div className="d-flex flex-wrap gap-2">
                              <button
                                className="d-flex align-items-center justify-content-center"
                                onClick={() =>
                                  openEmailModal(
                                    res.email,
                                    res.firstName,
                                    res.lastName,
                                  )
                                }
                                title="Send Email"
                                style={{
                                  marginLeft: 10,
                                  width: 36,
                                  height: 36,
                                  borderRadius: '8px',
                                  border: 'none',
                                  backgroundColor: '#3b82f6',
                                  color: '#fff',
                                }}
                              >
                                <MdEmail size={20} />
                              </button>
                              <button
                                className="d-flex align-items-center justify-content-center"
                                onClick={() =>
                                  openWhatsappModal(
                                    res.phoneNumber,
                                    res.firstName,
                                    res.lastName,
                                  )
                                }
                                title="WhatsApp"
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: '50%',
                                  border: 'none',
                                  backgroundColor: '#22c55e',
                                  color: '#fff',
                                }}
                              >
                                <MdWhatsapp size={20} />
                              </button>
                              <button
                                className="d-flex align-items-center justify-content-center"
                                onClick={() => handleView(res._id)}
                                title="View"
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: '50%',
                                  border: 'none',
                                  backgroundColor: '#e0edff',
                                  color: '#3b82f6',
                                }}
                              >
                                <FaEye size={20} />
                              </button>
                              <button
                                className="d-flex align-items-center justify-content-center"
                                onClick={() => updateToggle(res)}
                                title="Edit"
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: '8px',
                                  border: 'none',
                                  backgroundColor: '#16a34a',
                                  color: '#fff',
                                }}
                              >
                                <FaEdit size={18} />
                              </button>
                              <button
                                className="d-flex align-items-center justify-content-center"
                                onClick={() => deleteData(res._id)}
                                title="Delete"
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: '8px',
                                  border: 'none',
                                  backgroundColor: '#ef4444',
                                  color: '#fff',
                                }}
                              >
                                <MdDelete size={18} />
                              </button>
                            </div>
                          </Td> */}
                        </Tr>

                        <Tr sx={{ borderBottom: 'none' }}>
                          <Td fontWeight="bold" py="1">
                            <FiTarget className="inline-block  mr-2  text-purple-500" />
                            Lead From:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.leadFrom}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <FaPhone className="inline-block  mr-2  text-blue-500" />
                            Phone:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.phoneNumber}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <MdEmail className="inline-block  mr-2  text-blue-500" />
                            Email:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.email || 'N/A'}
                            </span>
                          </Td>

                          <Td colSpan={2}></Td>
                        </Tr>

                        <Tr sx={{ borderBottom: 'none' }}>
                          <Td fontWeight="bold" py="1">
                            <MdLocationOn className="inline-block  mr-2  text-red-500" />
                            Location:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.city
                                ? `${res.city}, ${res.country || ''}`
                                : 'N/A'}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <MdDateRange className="inline-block  mr-2  text-orange-500" />
                            Lead Received On:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.leadReceived || 'N/A'}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <FaUser className="inline-block mr-2 text-green-500" />
                            Lead Assign:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res?.counselorAssign?.name || '-'}
                            </span>
                          </Td>
                        </Tr>
                        <Tr sx={{ borderBottom: 'none' }}>
                          <Td fontWeight="bold" py="1">
                            <MdComment className="inline-block  mr-2  text-gray-500" />
                            Remark:&nbsp;&nbsp;
                            <span
                              style={{
                                fontWeight: 'normal',
                                display: 'contents',
                                maxWidth: '300px',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                              }}
                            >
                              {res.remark}
                            </span>
                          </Td>
                        </Tr>
                        <Tr>
                          <button
                            className="mobile-only-button py-[8px] px-[20px] rounded-full !bg-theme-dark fw-bold d-flex align-item-center border-0 text-white mt-2 ml-5"
                            onClick={() => handlePhoneClick(res.phoneNumber)}
                            title="Call"
                          >
                            <FaPhone size={18} className="mr-5 mt-1" /> call
                          </button>
                        </Tr>
                      </Tbody>
                    </Table>
                  </TableContainer>
                </div>
              ))
            ) : (
              <div className="text-center py-4 w-full">
                <p className="text-gray-500 font-medium">
                  No data found for the selected filters
                </p>
                <button
                  onClick={() => {
                    setSearchDefault({
                      page: '',
                      search: '',
                      startDate: '',
                      endDate: '',
                      status: '',
                    });
                    // setFormValues({ type: '' });
                    dispatch(leadGet(limits));
                  }}
                  className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm"
                >
                  Clear Filters
                </button>
              </div>
            )}
          </Table>
        </TableContainer>
      </div>

      {/* <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      /> */}
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        pageCount={PageCount}
        previousLabel="< prev"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      <FileUpdate
        updateModal={updateModal}
        updateToggle={updateToggle}
        updateId={updateId}
        searchDefault1={searchDefault}
      />
      <DeleteModal
        deleteModal={deleteModal}
        deleteToggle={deleteToggle}
        setChecked={setChecked}
        leadId={leadId}
        limits={limits}
        setLeadId={setLeadId}
        setMainPage={setMainPage}
        searchDefault1={searchDefault}
      />

      {/* WhatsApp Modal */}
      <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Lead Name</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedLeadName}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">
                Mobile Number
              </Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedMobileNumber}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">
                Select Message
              </Form.Label>
              <Form.Select
                className="border-2"
                value={whatsappDropdownSelection}
                onChange={(e) => {
                  setWhatsappDropdownSelection(e.target.value);
                  setErrors((prev) => ({ ...prev, dropdown: '' }));
                }}
              >
                <option value="">Select Option</option>
                {whatsAppMessage.map((msg) => (
                  <option key={msg._id} value={msg._id}>
                    {msg.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </Form.Select>
              {errors.dropdown && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: '0.875rem' }}
                >
                  {errors.dropdown}
                </div>
              )}
            </div>

            {whatsappDropdownSelection === 'other' && (
              <div className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Please specify"
                  className="border-2"
                  value={otherMessage}
                  onChange={(e) => {
                    setOtherMessage(e.target.value);
                    setErrors((prev) => ({ ...prev, other: '' }));
                  }}
                />
                {errors.other && (
                  <div
                    className="text-danger mt-1"
                    style={{ fontSize: '0.875rem' }}
                  >
                    {errors.other}
                  </div>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeWhatsappModal}>
            Cancel
          </Button>
          <Button className="!bg-theme-dark border-0 px-4" onClick={handleSend}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Email Modal */}
      <Modal show={isEmailModalOpen} onHide={closeEmailModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send Email Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="leadName">
              <Form.Label>Lead Name</Form.Label>
              <Form.Control
                type="text"
                value={selectedLeadName}
                readOnly
                disabled
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="emailRecipient">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                value={selectedEmailAddress}
                readOnly
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="emailTemplateSelect">
              <Form.Label>Select Template</Form.Label>
              <Form.Select
                value={emailDropdownSelection}
                onChange={(e) => setEmailDropdownSelection(e.target.value)}
              >
                <option value="">Select Option</option>
                {emailTemplates.map((template) => (
                  <option key={template._id} value={template._id}>
                    {template.title}
                  </option>
                ))}
                <option value="custom">Custom</option>
              </Form.Select>
            </Form.Group>

            {emailDropdownSelection === 'custom' && (
              <Form.Group className="mb-3" controlId="customMessage">
                <Form.Label>Custom Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={customEmailMessage}
                  onChange={(e) => setCustomEmailMessage(e.target.value)}
                  placeholder="Type your message here"
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeEmailModal}>
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4"
            onClick={handleSendEmail}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Bulk Follow-Up Date Modal ── */}
      <Modal
        show={bulkUpdateModal}
        onHide={() => {
          setBulkUpdateModal(false);
          setBulkFollowUpDate('');
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaRegClock className="inline-block me-2 text-blue-600" />
            Set Follow-Up Date
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3 bg-blue-50 border border-blue-200 rounded p-3 text-sm text-blue-800">
            This will set the same follow-up date for{' '}
            <strong>{leadId.length} selected lead(s)</strong>.
          </div>

          <Form.Group>
            <Form.Label className="fw-bold">
              Next Follow-Up Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={bulkFollowUpDate}
              min={new Date().toISOString().split('T')[0]} // prevent past dates
              onChange={(e) => setBulkFollowUpDate(e.target.value)}
              className="shadow-none"
            />
            {!bulkFollowUpDate && (
              <Form.Text className="text-muted">
                Please select a date to continue.
              </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setBulkUpdateModal(false);
              setBulkFollowUpDate('');
            }}
          >
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4 d-flex align-items-center gap-2"
            disabled={!bulkFollowUpDate || isBulkLoading}
            // onClick={async () => {
            //   if (!bulkFollowUpDate) return;
            //   setIsBulkLoading(true);
            //   try {
            //     const token = localStorage.getItem('token');

            //     // Call your existing update endpoint for each selected lead in parallel
            //     await Promise.all(
            //       leadId.map((id) => {
            //         const formData = new FormData();
            //         formData.append('patientId', id);
            //         formData.append('nextFollowUpDate', bulkFollowUpDate);
            //         return axios.put(
            //           `${BASEURL}/patient/updatePatient`, // 👈 replace with your actual update URL
            //           formData,
            //           { headers: { Authorization: `Bearer ${token}` } },
            //         );
            //       }),
            //     );

            //     toast.success(
            //       `Follow-up date set for ${leadId.length} lead(s) successfully!`,
            //     );

            //     // Reset state
            //     setBulkUpdateModal(false);
            //     setBulkFollowUpDate('');
            //     setLeadId([]);
            //     setChecked(false);

            //     // Refresh leads list
            //     const queryParams = new URLSearchParams({
            //       ...searchDefault,
            //       page: mainPage,
            //       limit: rowsPerPage,
            //     }).toString();
            //     dispatch(searchLead(queryParams));
            //   } catch (error) {
            //     toast.error(
            //       error?.response?.data?.message ||
            //         'Failed to update follow-up dates.',
            //     );
            //   } finally {
            //     setIsBulkLoading(false);
            //   }
            // }}

            // onClick={async () => {
            //   if (!bulkFollowUpDate) return;
            //   setIsBulkLoading(true);
            //   try {
            //     // Build one FormData per selected lead, mirroring exactly what updateLead does
            //     const updatePromises = leadId.map((id) => {
            //       const formData = new FormData();
            //       formData.append('patientId', id);
            //       formData.append('nextFollowUpDate', bulkFollowUpDate);

            //       const limits = { page: mainPage, limit: rowsPerPage };
            //       // Reuse your existing Redux updateLead action — no new endpoint needed
            //       return dispatch(
            //         updateLead(formData, limits, searchDefault.status, {
            //           page: mainPage,
            //           limit: rowsPerPage,
            //         }),
            //       );
            //     });
            onClick={async () => {
              if (!bulkFollowUpDate) return;
              setIsBulkLoading(true);
              try {
                const updatePromises = leadId.map((id) => {
                  // Find the lead data to get its existing Assigned manager
                  const leadData = getFile?.getAllLead?.data?.PatientData?.find(
                    (lead) => lead._id === id,
                  );

                  const formData = new FormData();
                  formData.append('patientId', id);
                  formData.append('nextFollowUpDate', bulkFollowUpDate);

                  // Preserve the existing Assigned manager
                  if (leadData?.counselorAssign?._id) {
                    formData.append(
                      'counselorAssign',
                      leadData.counselorAssign._id,
                    );
                  }

                  const limits = { page: mainPage, limit: rowsPerPage };
                  return dispatch(
                    updateLead(formData, limits, searchDefault.status, {
                      page: mainPage,
                      limit: rowsPerPage,
                    }),
                  );
                });

                await Promise.all(updatePromises);

                toast.success(
                  `Follow-up date updated for ${leadId.length} lead(s) successfully!`,
                );

                // Reset everything
                setBulkUpdateModal(false);
                setBulkFollowUpDate('');
                setLeadId([]);
                setChecked(false);

                // Refresh the list
                const queryParams = new URLSearchParams({
                  ...searchDefault,
                  page: mainPage,
                  limit: rowsPerPage,
                }).toString();
                dispatch(searchLead(queryParams));
              } catch (error) {
                console.error('Bulk update error:', error);
                toast.error(
                  error?.response?.data?.message ||
                    'Failed to update follow-up dates.',
                );
              } finally {
                setIsBulkLoading(false);
              }
            }}
          >
            {isBulkLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Updating...
              </>
            ) : (
              <>
                <FaRegClock />
                Update {leadId.length} Lead(s)
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Bulk Assign Manager Modal ── */}
      <Modal
        show={bulkAssignManagerModal}
        onHide={() => {
          setBulkAssignManagerModal(false);
          setBulkSelectedManagerId('');
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaUser className="inline-block me-2 text-blue-600" />
            Assign Manager
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3 bg-blue-50 border border-blue-200 rounded p-3 text-sm text-blue-800">
            This will assign the same manager to{' '}
            <strong>{leadId.length} selected lead(s)</strong>.
          </div>

          <Form.Group>
            <Form.Label className="fw-bold">
              Select Manager <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              value={bulkSelectedManagerId}
              onChange={(e) => setBulkSelectedManagerId(e.target.value)}
              className="shadow-none"
            >
              <option value="">-- Select a Manager --</option>
              {managers.map((manager) => (
                <option key={manager._id} value={manager._id}>
                  {manager.name}
                </option>
              ))}
            </Form.Select>
            {!bulkSelectedManagerId && (
              <Form.Text className="text-muted">
                Please select a manager to continue.
              </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setBulkAssignManagerModal(false);
              setBulkSelectedManagerId('');
            }}
          >
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4 d-flex align-items-center gap-2"
            disabled={!bulkSelectedManagerId || isBulkManagerLoading}
            onClick={async () => {
              if (!bulkSelectedManagerId) return;
              setIsBulkManagerLoading(true);
              try {
                const updatePromises = leadId.map((id) => {
                  const formData = new FormData();
                  formData.append('patientId', id);
                  formData.append('counselorAssign', bulkSelectedManagerId);

                  // if (leadData?.nextFollowUpDate) {
                  //   formData.append(
                  //     'nextFollowUpDate',
                  //     leadData.nextFollowUpDate,
                  //   );
                  // }

                  return dispatch(
                    updateLead(
                      formData,
                      { page: mainPage, limit: rowsPerPage },
                      searchDefault.status,
                      {
                        page: mainPage,
                        limit: rowsPerPage,
                      },
                    ),
                  );
                });

                await Promise.all(updatePromises);

                toast.success(
                  `Manager assigned to ${leadId.length} lead(s) successfully!`,
                );

                // Reset
                setBulkAssignManagerModal(false);
                setBulkSelectedManagerId('');
                setLeadId([]);
                setChecked(false);

                // Refresh list
                const queryParams = new URLSearchParams({
                  ...searchDefault,
                  page: mainPage,
                  limit: rowsPerPage,
                }).toString();
                dispatch(searchLead(queryParams));
              } catch (error) {
                console.error('Bulk assign manager error:', error);
                toast.error(
                  error?.response?.data?.message || 'Failed to assign manager.',
                );
              } finally {
                setIsBulkManagerLoading(false);
              }
            }}
          >
            {isBulkManagerLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Assigning...
              </>
            ) : (
              <>
                <FaUser />
                Assign to {leadId.length} Lead(s)
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
